import React from 'react';
import { formatPrice } from '../services/raffleService';
import { useTranslation } from '../hooks/useTranslation';

const RaffleHeader = ({ raffle, stats }) => {
  const { t } = useTranslation();
  const calculateProgress = () => {
    const soldPercentage = ((stats.sold + stats.reserved) / stats.total) * 100;
    return Math.round(soldPercentage);
  };

  const progress = calculateProgress();

  return (
    <div className="bg-gradient-to-r from-primary to-secondary text-white">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="animate-fadeIn">
          {/* Mostrar imagen si existe */}
          {raffle.imageUrl && (
            <div className="mb-6">
              <img 
                src={raffle.imageUrl} 
                alt={raffle.name}
                className="w-full max-w-md mx-auto rounded-lg shadow-xl"
                style={{ maxHeight: '300px', objectFit: 'cover' }}
                onError={(e) => {
                  console.error('Error loading image:', e);
                  e.target.style.display = 'none';
                }}
              />
            </div>
          )}
          
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            {raffle.name}
          </h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div className="bg-white/10 rounded-lg p-4">
              <p className="text-sm opacity-90">{t('common.organizer')}</p>
              <p className="text-lg font-semibold">{raffle.organizer}</p>
            </div>
            
            <div className="bg-white/10 rounded-lg p-4">
              <p className="text-sm opacity-90">{t('common.price')}</p>
              <p className="text-lg font-semibold">
                {formatPrice(raffle.price)}
              </p>
            </div>
            
            <div className="bg-white/10 rounded-lg p-4">
              <p className="text-sm opacity-90">{t('common.date')}</p>
              <p className="text-lg font-semibold">{raffle.date}</p>
            </div>
            
            <div className="bg-white/10 rounded-lg p-4">
              <p className="text-sm opacity-90">{t('common.lottery')}</p>
              <p className="text-lg font-semibold">{raffle.lottery}</p>
            </div>
          </div>

          {/* Barra de progreso */}
          <div className="bg-white/20 rounded-full h-8 relative overflow-hidden">
            <div 
              className="bg-white/50 h-full transition-all duration-500 ease-out flex items-center justify-center"
              style={{ width: `${progress}%` }}
            >
              {progress > 10 && (
                <span className="text-sm font-medium">{progress}%</span>
              )}
            </div>
            {progress <= 10 && (
              <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-sm font-medium">
                {progress}%
              </span>
            )}
          </div>
          
          <div className="mt-4 flex flex-wrap gap-4 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-green-400 rounded"></div>
              <span>{t('stats.available')}: {stats.available}</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-yellow-400 rounded"></div>
              <span>{t('stats.reserved')}: {stats.reserved}</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-red-400 rounded"></div>
              <span>{t('stats.sold')}: {stats.sold}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RaffleHeader;